import type { WebapiEndpointBuilder } from '@/api/webapi.ts';

interface GetPinnedCompaniesResult {
  pinnedCompanies: number[];
}

export const getPinnedCompanies = (builder: WebapiEndpointBuilder) =>
  builder.query<GetPinnedCompaniesResult, void>({
    query: () => ({
      url: '/userdata/pinned',
      method: 'GET',
    }),
  });
